import React, { useState } from "react";
import "./booknow.css";
import { Modal, Button } from "react-bootstrap";
import { jsPDF } from "jspdf";
import emailjs from "emailjs-com";
import singleRoom from "../../assets/single-rooms.jpg";
import doubleRoom from "../../assets/double-room.jpg";
import Presidential from "../../assets/Presidential-Suite.jpg";
import studio from "../../assets/Studio.jpg";
import "jspdf-autotable";
export const BookNow = () => {
  const [bookingDetails, setBookingDetails] = useState({
    customerName: "",
    customerPhone: "",
    customerEmail: "",
    checkIn: "",
    checkOut: "",
    roomType: "",
    noOfPerson: 1,
    advance: 0,
  });
  const [totalDays, setTotalDays] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const roomRates = {
    Single: 1000,
    Double: 2000,
    Presidential: 3000,
    Suite: 4500,
  };

  const roomImages = {
    Single: singleRoom,
    Double: doubleRoom,
    Presidential: Presidential,
    Suite: studio,
  };

  const currencyFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
    }).format(value);

  const calculateTotalDays = (checkIn, checkOut) => {
    if (checkIn && checkOut) {
      const start = new Date(checkIn);
      const end = new Date(checkOut);
      const days = Math.max(
        0,
        Math.ceil((end - start) / (1000 * 60 * 60 * 24))
      );
      setTotalDays(days);
      return days;
    }
    return 0;
  };

  const calculateTotalAmount = (roomType, days, noOfPerson) => {
    if (roomType && days && noOfPerson) {
      const amount = days * (roomRates[roomType] || 0) * noOfPerson;
      setTotalAmount(amount);
      return amount;
    }
    return 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedDetails = { ...bookingDetails, [name]: value };
    setBookingDetails(updatedDetails);

    if (name === "checkIn" || name === "checkOut") {
      const days = calculateTotalDays(
        updatedDetails.checkIn,
        updatedDetails.checkOut
      );
      calculateTotalAmount(
        updatedDetails.roomType,
        days,
        updatedDetails.noOfPerson
      );
    }

    if (name === "roomType" || name === "noOfPerson") {
      calculateTotalAmount(
        updatedDetails.roomType,
        totalDays,
        updatedDetails.noOfPerson
      );
    }

    if (name === "advance") {
      const advanceValue = Math.min(Number(value), totalAmount);
      setBookingDetails({ ...updatedDetails, advance: advanceValue });
    }
  };
  const sendEmailConfirmation = () => {
    const emailParams = {
      customerEmail: bookingDetails.customerEmail,
      customerName: bookingDetails.customerName,
      customerPhone: bookingDetails.customerPhone,
      checkIn: bookingDetails.checkIn,
      checkOut: bookingDetails.checkOut,
      roomType: bookingDetails.roomType,
      totalAmount: currencyFormat(totalAmount),
      advance: currencyFormat(bookingDetails.advance),
      balance: currencyFormat(totalAmount - bookingDetails.advance),
    };

    emailjs
      .send(
        "service_v7z8t1h",
        "template_ierwz48",
        emailParams,
        "7eHYgX89MTuDBu3W3"
      )
      .then((response) => console.log("Email sent:", response))
      .catch((error) => console.error("Error sending email:", error));
  };
  const handleBooking = () => {
    const defaultAdvance = Math.min(5000, totalAmount * 0.3);
    const advance = bookingDetails.advance || defaultAdvance;
    setBookingDetails((prev) => ({ ...prev, advance }));
    sendEmailConfirmation();
    setShowModal(true);
  };
  const generatePDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(16);
    doc.text("MV Hotel Booking Confirmation", 14, 15);
    const totalCal = totalAmount - bookingDetails.advance;
    // Table Data
    const tableColumn = ["Field", "Details"];
    const tableRows = [
      ["Name", bookingDetails.customerName],
      ["Phone", bookingDetails.customerPhone],
      ["Email", bookingDetails.customerEmail],
      ["Check-In", bookingDetails.checkIn],
      ["Check-Out", bookingDetails.checkOut],
      ["Room Type", bookingDetails.roomType],
      ["Number of Persons", bookingDetails.noOfPerson],
      ["Total Amount", totalAmount.toLocaleString()],
      ["Advance Paid", bookingDetails.advance.toLocaleString()],
      ["Balance Due", totalCal.toLocaleString()],
    ];

    // Add Table
    doc.autoTable({
      startY: 25, // Position below title
      head: [tableColumn],
      body: tableRows,
      theme: "striped",
      styles: { fontSize: 12 },
      headStyles: { fillColor: [22, 160, 133] }, // Green header like invoices
    });

    // Save PDF
    doc.save("booking-confirmation.pdf");

    // Reload Page (if needed)
    setTimeout(() => {
      window.location.reload();
    }, 500);
  };

  const handlePay = () => {
    alert("Done");
  };
  return (
    <div className="booknow-page">
      <h1>Book Your Stay</h1>
      <form className="booking-form">
        {[
          {
            label: "Full Name",
            name: "customerName",
            type: "text",
            placeholder: "Enter Your Full Name",
          },
          {
            label: "Whatsapp Phone Number",
            name: "customerPhone",
            type: "tel",
            placeholder: "Enter Your Number",
          },
          {
            label: "Email",
            name: "customerEmail",
            type: "email",
            placeholder: "Enter Your Email",
          },
        ].map((field) => (
          <label key={field.name}>
            {field.label}:
            <input
              type={field.type}
              name={field.name}
              className="input-transparent"
              autoComplete="off"
              placeholder={field.placeholder}
              value={bookingDetails[field.name]}
              onChange={handleChange}
              required
            />
          </label>
        ))}

        <label>
          Check-In Date:
          <input
            type="date"
            name="checkIn"
            autoComplete="off"
            className="input-transparent"
            value={bookingDetails.checkIn}
            onChange={handleChange}
            min={new Date().toISOString().split("T")[0]}
            required
          />
        </label>

        <label>
          Check-Out Date:
          <input
            type="date"
            name="checkOut"
            className="input-transparent"
            autoComplete="off"
            value={bookingDetails.checkOut}
            onChange={handleChange}
            min={
              bookingDetails.checkIn || new Date().toISOString().split("T")[0]
            }
            required
          />
        </label>

        <label>
          Number of Persons:
          <input
            type="number"
            name="noOfPerson"
            className="input-transparent"
            value={bookingDetails.noOfPerson}
            onChange={handleChange}
            autoComplete="off"
            min="1"
            required
          />
        </label>

        <label>
          Room Type:
          <select
            name="roomType"
            className="input-bg"
            value={bookingDetails.roomType}
            onChange={handleChange}
            autoComplete="off"
            required
          >
            <option value="" disabled>
              Select Room Type
            </option>
            {Object.keys(roomRates).map((type) => (
              <option key={type} value={type}>
                {type} (₹{roomRates[type]}/day)
              </option>
            ))}
          </select>
        </label>

        {bookingDetails.roomType && (
          <div className="room-image">
            <img
              src={roomImages[bookingDetails.roomType]}
              alt={`${bookingDetails.roomType} room`}
            />
          </div>
        )}

        <label>
          Advance Payment (₹):
          <input
            className="input-transparent"
            type="number"
            name="advance"
            value={bookingDetails.advance}
            autoComplete="off"
            onChange={handleChange}
            min="0"
            max={totalAmount}
          />
        </label>

        <div className="button-container">
          <button
            type="button"
            className="confirm-btn btn btn-success w-25"
            onClick={handlePay}
          >
            Pay
          </button>
          <button
            type="button"
            className="confirm-btn btn btn-dark w-75"
            onClick={handleBooking}
          >
            Confirm Booking
          </button>
        </div>
      </form>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Booking Confirmed</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Thank you, {bookingDetails.customerName}! , Your Booking Confirmed
            Details Sent to Your Email, please Check Mail
          </p>
          <p>Your Email Id : {bookingDetails.customerEmail}</p>
          <p>
            Booking Details: {totalDays} days, {bookingDetails.roomType} Room
          </p>
          <p>Number of Persons: {bookingDetails.noOfPerson}</p>
          <p>Total Amount: {currencyFormat(totalAmount)}</p>
          <p>Advance Paid: {currencyFormat(bookingDetails.advance)}</p>
          <p>
            Balance Due: {currencyFormat(totalAmount - bookingDetails.advance)}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={generatePDF}>
            Download PDF
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
